// packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import DatePicker from 'react-datepicker';
import moment from 'moment';
// styles
import 'font-awesome/less/font-awesome.less';
import './RelatedTransaction.less';

class RelatedTransactionsParser extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    case_uuid: PropTypes.string,
    loadingSpinner: PropTypes.bool,
  };

  static defaultProps = {
    case_uuid: '',
    onSubmit: () => null,
    loadingSpinner: false,
  };

  render() {
    const {
      onSubmit,
      loadingSpinner,
      onReset,
    } = this.props;

    const DateField = ({ input, label, ...rest }) => (
      <DatePicker
        {...input}
        minDate={moment().subtract(15, 'years')}
        maxDate={moment()}
        selected={input.value ? moment(input.value) : null}
        dateFormat="MM/DD/YYYY"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        placeholderText="date"
        {...rest}
      />
    );
    const pending = true;
    return (
      <Form
      initialValues={{ pending }}
      onSubmit={onSubmit}
      render={({
        handleSubmit,
        pristine,
        form,
        submitting,
        }) => (
          <div id="pacer-filter" className="inside-block">
            {!this.props.showPacerFilterSection &&
            <form onSubmit={handleSubmit} id="related-form-parser">
              <div className="related-form-row">
                <label htmlFor="keyword"> 
                  <Field
                    name="keyword"
                    component="input"
                    id="alfresco-keyword"
                    type="text"
                    placeholder="Find what"
                    />
                </label>
                <Field
                  name="doc_from"
                  component="input"
                  type="text"
                  placeholder="Doc#"
                  />
                <label htmlFor="doc_to">
                  <Field
                    name="doc_to"
                    component="input"
                    type="text"
                    placeholder="Doc#"
                />
                </label>
                <label htmlFor="date_from">
                  <Field
                      name="date_from"
                      component={DateField}
                      type="text"
                      placeholder="Date"
                  />
                </label>
                <label htmlFor="date_to">
                  <Field
                      name="date_to"
                      component={DateField}
                      type="text"
                      placeholder="Date"
                  />
                </label>
                <button type="submit" disabled={submitting} className="form-submit">
                  {loadingSpinner ? <i className="fa fa-spinner fa-spin" /> : <div className="magnifier icon" />}
                </button>
                <button
                  type="reset"
                  onClick={() => onReset()}
                  disabled={submitting}
                  className="form-reset">
                  Clear/ Show All
                </button>
              </div>
            </form>
          }
          </div>)}
      />
    );
  }
}

export default RelatedTransactionsParser;



// WEBPACK FOOTER //
// ./src/components/case/related_transaction/RelatedTransactionsParser.jsx